import { sumValues, throwTranslatableError } from '@/core';
import { updateTripsRequest } from '../../requests';
import deepCopy from 'deepcopy';
import createTripOrder from './addOrdersToTrip/createTripOrder';
import rdbClient from 'rdb-client';

export default async function moveOrderToDifferentTrip({ commit }, { subOrder, originalTrip, newTrip, despatchOption, deliveryOption, etd, eta, customDespatchParty, customDeliveryParty }) {
	if (!subOrder || !newTrip) {
		throw new Error('failedToAddOrderToTrip');
	}

	let tripCopy = deepCopy(originalTrip);
	let originalTripClone = deepCopy(originalTrip);

	if (tripCopy.orders) {
		let orderIndex = tripCopy.orders.findIndex(x => x.id === subOrder.id);
		tripCopy.orders.splice(orderIndex, 1);
		tripCopy.volume = sumValues(tripCopy.orders, 'volume');
		tripCopy.grossWeight = sumValues(tripCopy.orders, 'grossWeight');
		tripCopy.loadingMeters = sumValues(tripCopy.orders, 'loadingMeters');
	}

	let maxLoadingSeqNo = newTrip.orders ? newTrip.orders.reduce((p,c) => ((c.loadingSeqNo && c.loadingSeqNo > p.loadingSeqNo) ? c : p), 0) : 0;
	if (!maxLoadingSeqNo) maxLoadingSeqNo = 0;
	let newOrder = createTripOrder(subOrder, newTrip, etd, eta, despatchOption, deliveryOption, customDespatchParty, customDeliveryParty, maxLoadingSeqNo++);

	let newTripCopy = deepCopy(newTrip);
	let newTripClone = deepCopy(newTrip);
	if (!newTripCopy.orders) newTripCopy.orders = [];
	newTripCopy.orders.push(newOrder);
	if (newTripCopy.orders) {
		newTripCopy.volume = sumValues(newTripCopy.orders, 'volume');
		newTripCopy.grossWeight = sumValues(newTripCopy.orders, 'grossWeight');
		newTripCopy.loadingMeters = sumValues(newTripCopy.orders, 'loadingMeters');
	}
	try {
		let originalData = [ originalTripClone, newTripClone ];
		let updatedData = [ tripCopy, newTripCopy ];
		let patch = rdbClient.createPatch(originalData, updatedData);
		let response = await updateTripsRequest({ ids: [tripCopy.id, newTripCopy.id], patch });
		let trip = response.find(x => x.id === originalTripClone.id);
		commit('setEditTrip', trip);
	} catch (e) {
		console.log(e);
		throwTranslatableError(e, 'failedToAddOrderToTrip');
	}
}